function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import window from 'window-or-global';
const encode = encodeURIComponent;

const getMailtoLink = function getMailtoLink({
  subject,
  to,
  body,
  cc,
  bcc
}) {
  const link = [cc ? `cc=${cc}` : null, bcc ? `bcc=${bcc}` : null, subject ? `subject=${encode(subject)}` : null, body ? `body=${encode(body)}` : null].filter(Boolean);
  return `${to}?${link.join('&')}&_c=${Date.now()}`;
};

const handleSecureClick = (to, onClick) => event => {
  var _window$location, _window$location$assi;

  event.preventDefault();
  onClick === null || onClick === void 0 ? void 0 : onClick(event); // @ts-ignore

  window === null || window === void 0 ? void 0 : (_window$location = window.location) === null || _window$location === void 0 ? void 0 : (_window$location$assi = _window$location.assign) === null || _window$location$assi === void 0 ? void 0 : _window$location$assi.call(_window$location, to);
};

export const Mailto = ({
  to,
  cc,
  bcc,
  subject,
  body,
  secure,
  ...props
}) => {
  const link = getMailtoLink({
    to,
    cc,
    bcc,
    subject,
    body
  });
  const isSecure = secure === true;
  const href = `mailto:${link}`;
  const onClick = isSecure ? handleSecureClick(href, props.onClick) : props.onClick;
  return /*#__PURE__*/React.createElement("a", _extends({}, props, {
    href: isSecure ? '' : href,
    onClick: onClick
  }));
};